// extracted by mini-css-extract-plugin
module.exports = {"PartnerSkinPrefs":"PartnerSkinPrefs_PartnerSkinPrefs__1VETL","Actions":"PartnerSkinPrefs_Actions__7r4VG"};